import * as React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import useWindowResize from '../../../hooks/useWindowSize';
import { ContactDisplayLayout } from '../../../sic-lib/enums/ContactDisplayLayout';
import { GenericReducer, genericReducer } from '../../../sic-lib/reducers/genericReducer';
import { Contact } from '../../../sic-lib/types/Contact';
import Aside from '../Aside/Aside';
import ContactMain from '../ContactMain/ContactMain';

interface ContactDisplayState {
    view: ContactDisplayLayout;
}

interface Props {
    contact: Contact;
}

export default function ContactLayout({ contact }: Props) {
    /*
        IMPORTANT: this is the screen size listener for the ContactDisplayPage componet tree,
        only one should be active within the page at a time.
     */
    const { hasMediumScreen } = useWindowResize();

    const [cdState, cdDispatch] = React.useReducer<GenericReducer<ContactDisplayState>>(
        genericReducer,
        {
            view: ContactDisplayLayout.main,
        },
    );

    React.useEffect(() => {
        if (!hasMediumScreen && cdState.view !== ContactDisplayLayout.main) {
            cdDispatch({ view: ContactDisplayLayout.main });
        }
    }, [contact.contactId]);

    /* 
        TIP: transition is for screens smaller than hasMediumScreen.
        Use 'appear' transitionGroup prop to prevent transitioning on larger screens
     */
    return (
        <TransitionGroup
            component="div"
            className={`contactDisplay__transitionWrapper`}
            appear={hasMediumScreen}
        >
            <CSSTransition key={cdState.view} timeout={160} mountOnEnter>
                <div className="contactDisplay__transition">
                    {(hasMediumScreen || cdState.view === ContactDisplayLayout.main) && (
                        <ContactMain
                            contact={contact}
                            hasMediumScreen={hasMediumScreen}
                            cdDispatch={cdDispatch}
                        />
                    )}
                    {(hasMediumScreen || cdState.view === ContactDisplayLayout.aside) && (
                        <Aside contact={contact} cdDispatch={cdDispatch} />
                    )}
                </div>
            </CSSTransition>
        </TransitionGroup>
    );
}
